export const SeamlessViewMapConstants = {
    CommonLayers: [
        {
            layerNameType: 'STATE',
            serviceType: 'WmsLayer',
            view: 'Both',
            type: 'Base',
            env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
            pane: 'village',
            styles: 'INDIA_STATE_NAMES',
            maxZoom: 7
        },
        {
            layerNameType : 'MASK_LAYER',
            serviceType : 'WmsLayer',
            name : 'stateMask',
            view : 'Both',
            type : 'Inverse',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'mask',
            styles:'HEATWAVE:world_view_white,HEATWAVE:inverse_mask',
          },
        {
            layerNameType : 'DISTRICT',
            serviceType : 'VectorLayer',
            view : 'Both',
            type : 'Base',
            interactive : true,
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'district',
        },
        {
            layerNameType : 'DISTRICT',
            serviceType : 'WmsLayer',
            view : 'Both',
            type : 'Base',
            env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
            pane : 'district',
            styles:'INDIA_DISTRICT_NAMES',
            minZoom:7,
            maxZoom:9,
          },
        {
            layerNameType: 'BLOCKS',
            serviceType: 'WmsLayer',
            view: 'Both',
            type: 'Base',
            env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
            pane: 'village',
            styles: 'ALL_INDIA_BLOCK_NAMES',
            minZoom: 10
        },
        // {
        //     layerNameType: 'BLOCKS',
        //     serviceType: 'WmsLayer',
        //     view: 'Both',
        //     type: 'Base',
        //     env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        //     pane: 'village',
        //     styles: 'ALL_INDIA_STATE_NAMES_BORDER',
        //     minZoom: 10
        // }
    ],

    HeatMapUrl: 'nowcast/getNowcastModelInputHeatMaps',

    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    },
    legendData: {
        IMD_RADAR_MODEL_INPUT_NOWCAST: {
            levels: [
                {
                    color: '#ffffff',
                    name: '%'
                },
                {
                    color: '#F7340A',
                    name: '>90'
                },
                {
                    color: '#FF6C0D',
                    name: '80'
                },
                {
                    color: '#FF9507',
                    name: '70'
                },
                {
                    color: '#E9CB2E',
                    name: '60'
                },
                {
                    color: '#63B86C',
                    name: '50'
                },
                {
                    color: '#167D9C',
                    name: '30'
                },
                {
                    color: '#2944BE',
                    name: '0'
                }
            ]
        },
        CTT_MODEL_INPUT_NOWCAST: {
            levels: [
                {
                  color: '#ffffff',
                  name: '%'
                },
                {
                  color : '#F7340A',
                  name : '>90'
                },
                {
                  color : '#FF6C0D',
                  name : '80'
                },
                {
                  color : '#FF9507',
                  name : '70'
                },
                {
                  color : '#E9CB2E',
                  name : '60'
                },
                {
                  color : '#63B86C',
                  name : '50'
                },
                {
                  color : '#167D9C',
                  name : '30'
                },
                {
                  color : '#2944BE',
                  name : '0'
                }
              ]
        },
        EUMETSAT_MODEL_INPUT_NOWCAST: {
            levels: [
                {
                  color: '#ffffff',
                  name: '%'
                },
                {
                  color : '#F7340A',
                  name : '>90'
                },
                {
                  color : '#FF6C0D',
                  name : '80'
                },
                {
                  color : '#FF9507',
                  name : '70'
                },
                {
                  color : '#E9CB2E',
                  name : '60'
                },
                {
                  color : '#63B86C',
                  name : '50'
                },
                {
                  color : '#167D9C',
                  name : '30'
                },
                {
                  color : '#2944BE',
                  name : '0'
                }
              ]
        },
        // MODEL_INPUT_NOWCAST: {
        //     levels: [
        //         {
        //             color: '#ffffff',
        //             name: '%'
        //         },
        //         {
        //             color: '#F7340A',
        //             name: '>90'
        //         },
        //         {
        //             color: '#FF6C0D',
        //             name: '80'
        //         },
        //         {
        //             color: '#FF9507',
        //             name: '70'
        //         },
        //         {
        //             color: '#E9CB2E',
        //             name: '60'
        //         },
        //         {
        //             color: '#63B86C',
        //             name: '50'
        //         },
        //         {
        //             color: '#167D9C',
        //             name: '30'
        //         },
        //         {
        //             color: '#2944BE',
        //             name: '0'
        //         }
        //     ]
        // },

    },

    IMD_RADAR_MODEL_INPUT_NOWCAST: {
        Legend: {
            colorValues: [
                {
                    backgroundColor: '#e6eeff',
                    color: '#000000',
                    text: '0'
                },
                {
                    backgroundColor: '#e6eeff',
                    color: '#000000',
                    text: '5'
                },
                {
                    backgroundColor: '#80aaff',
                    color: '#000000',
                    text: '10'
                },
                {
                    backgroundColor: '#3377ff',
                    color: '#000000',
                    text: '15'
                },
                {
                    backgroundColor: '#3377ff',
                    color: '#000000',
                    text: '20'
                },
                {
                    backgroundColor: '#003cb3',
                    color: '#ffffff',
                    text: '25'
                },
                {
                    backgroundColor: '#002266',
                    color: '#ffffff',
                    text: '30'
                },
                {
                    backgroundColor: '#ff80b3',
                    color: '#000000',
                    text: '35'
                },
                {
                    backgroundColor: '#ff80b3',
                    color: '#000000',
                    text: '40'
                },
                {
                    backgroundColor: '#ff0066',
                    color: '#000000',
                    text: '45'
                },
                {
                    backgroundColor: '#ff0066',
                    color: '#000000',
                    text: '50'
                },
                {
                    backgroundColor: '#cc0000',
                    color: '#000000',
                    text: '55'
                },
                {
                    backgroundColor: '#cc0000',
                    color: '#000000',
                    text: '60'
                },
                {
                    backgroundColor: '#660000',
                    color: '#ffffff',
                    text: '65'
                },
                {
                    backgroundColor: '#ffcccc',
                    color: '#000000',
                    text: '>70'
                },
                // {
                //   backgroundColor: '#ffcccc',
                //   color: '#000000',
                //   text: '75'
                // }
            ],
            Units: 'dbZ'
        },
    },

    CTT_MODEL_INPUT_NOWCAST: {
        Legend: {
            colorValues: [
                {
                    backgroundColor: '#ffcccc',
                    color: '#000000',
                    text: '-93'
                },
                {
                    backgroundColor: '#e0b3b3',
                    color: '#000000',
                    text: '-85.5'
                },
                {
                    backgroundColor: '#9e1001',
                    color: '#ffffff',
                    text: '-78'
                },
                {
                    backgroundColor: '#b41b01',
                    color: '#ffffff',
                    text: '-70.5'
                },
                {
                    backgroundColor: '#ff0066',
                    color: '#000000',
                    text: '-63'
                },
                {
                    backgroundColor: '#ff0066',
                    color: '#000000',
                    text: '-55.5'
                },
                {
                    backgroundColor: '#ff80b3',
                    color: '#000000',
                    text: '-48'
                },
                {
                    backgroundColor: '#ff80b3',
                    color: '#000000',
                    text: '-40.5'
                },
                {
                    backgroundColor: '#002266',
                    color: '#ffffff',
                    text: '-33'
                },
                {
                    backgroundColor: '#003cb3',
                    color: '#ffffff',
                    text: '-20'
                },
                {
                    backgroundColor: '#3377ff',
                    color: '#000000',
                    text: '-10'
                },
                {
                    backgroundColor: '#80aaff',
                    color: '#000000',
                    text: '00.0'
                },
                {
                    backgroundColor: '#b3cce6',
                    color: '#000000',
                    text: '10.0'
                },
                {
                    backgroundColor: '#e6eeff',
                    color: '#000000',
                    text: '20.0'
                },
                {
                    backgroundColor: '#b3cce6',
                    color: '#000000',
                    text: '30.0'
                },
                {
                    backgroundColor: '#80aaff',
                    color: '#000000',
                    text: '>40.0'
                },
                // {
                //   backgroundColor: '#80aaff',
                //   color: '#000000',
                //   text: '50.0'
                // },
            ],
            Units: '(°C)'
        },
    },

    EUMETSAT_MODEL_INPUT_NOWCAST: {
        Legend: {
            colorValues: [
                {
                    backgroundColor: '#e6eeff',
                    color: '#000000',
                    text: '0.5'
                },
                {
                    backgroundColor: '#80aaff',
                    color: '#000000',
                    text: '2.5'
                },
                {
                    backgroundColor: '#3377ff',
                    color: '#000000',
                    text: '5'
                },
                {
                    backgroundColor: '#003cb3',
                    color: '#000000',
                    text: '10'
                },
                {
                    backgroundColor: '#002266',
                    color: '#000000',
                    text: '20'
                },
                {
                    backgroundColor: '#ff80b3',
                    color: '#000000',
                    text: '30'
                },
                {
                    backgroundColor: '#ff0066',
                    color: '#000000',
                    text: '40'
                },
                {
                    backgroundColor: '#cc0000',
                    color: '#000000',
                    text: '50'
                },
                {
                    backgroundColor: '#660000',
                    color: '#000000',
                    text: '75'
                },
                {
                    backgroundColor: '#ffcccc',
                    color: '#000000',
                    text: '>100'
                },
                // {
                //   backgroundColor: '#ffcccc',
                //   color: '#000000',
                //   text: '1000'
                // }
            ],
            Units: 'mm/hr'
        },
    },
    MODEL_INPUT_NOWCAST: {
        Legend: {
            colorValues: [
                {
                  backgroundColor: '#ffcccc',
                  color: '#000000',
                  text: '>100'
                },
                {
                  backgroundColor: '#660000',
                  color: '#000000',
                  text: '75-100'
                },
                {
                  backgroundColor: '#cc0000',
                  color: '#000000',
                  text: '50-75'
                },
                {
                  backgroundColor: '#ff0066',
                  color: '#000000',
                  text: '40-50'
                },
                {
                  backgroundColor: '#ff80b3',
                  color: '#000000',
                  text: '30-40'
                },
                {
                  backgroundColor: '#002266',
                  color: '#000000',
                  text: '20-30'
                },
                {
                  backgroundColor: '#003cb3',
                  color: '#000000',
                  text: '10-20'
                },
                {
                  backgroundColor: '#3377ff',
                  color: '#000000',
                  text: '5-10'
                },
                {
                  backgroundColor: '#80aaff',
                  color: '#000000',
                  text: '2.5-5'
                },
                {
                  backgroundColor: '#e6eeff',
                  color: '#000000',
                  text: '0.5-2.5'
                },
                {
                  backgroundColor: 'transparent',
                  color: '#000000',
                  text: '0-0.5'
                }
              ],
            Units: 'mm/hr'
        },
    },

    SOURCE_LIST: [
        {
            source: 'IMD',
            forecastLengthList: ['24', '10']
        },
        {
            source: 'ECMWF',
            forecastLengthList: ['24', '10', 'weekly']
        },
        {
            source: 'IMD (WRF + GFS)',
            forecastLengthList: ['24', '10']
        },
    ],
    //   {
    //     source: 'ECMWF',
    //     forecastLengthList: ['24', '10', 'weekly']
    //   },
    //   {
    //     source: 'IMD (WRF + GFS)',
    //     forecastLengthList: ['24', '10']
    //   },
    //   {
    //     source: 'IMD (GFS)',
    //     forecastLengthList: ['24', '10']
    //   },
    // ]  

    LOCTYPE_LAYER_MAPPING : {
        'State' : 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
        'District' : 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED'
      },

      SOURCE_MAPPING : {
        IMD_RADAR_MODEL_INPUT_NOWCAST : 'IMD(dbZ)',
        CTT_MODEL_INPUT_NOWCAST : 'METEOLOGIX/IMD RAPID (°C)',
        EUMETSAT_MODEL_INPUT_NOWCAST : 'EUMETSAT (mm/hr)'
      },
        SOURCE_MAPPING_1 : {
        IMD_RADAR_MODEL_INPUT_NOWCAST : 'IMD(dbZ)',
        CTT_MODEL_INPUT_NOWCAST : 'METEOLOGIX/IMD RAPID (°C)',
        EUMETSAT_MODEL_INPUT_NOWCAST : 'EUMETSAT (mm/hr)'
      },
      SOURCE_MAPPING_FILE : {
        IMD_RADAR_MODEL_INPUT_NOWCAST : 'RADAR',
        CTT_MODEL_INPUT_NOWCAST : 'CTT',
        EUMETSAT_MODEL_INPUT_NOWCAST : 'EUMETSAT'
      },
      SOURCE_MAPPING_TITLE : {
        IMD_RADAR_MODEL_INPUT_NOWCAST : 'RADAR ( dbZ )',
        CTT_MODEL_INPUT_NOWCAST : 'CTT ( °C )',
        EUMETSAT_MODEL_INPUT_NOWCAST : 'EUMETSAT ( mm/hr )',
        MODEL_INPUT_NOWCAST : 'RAINFALL ( mm/hr )'
      }
}
